import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import Login from "../login/Login";

// Helpers
import Axios from '../../../helpers/axios'
import { timer } from "../../../helpers/timer";
import useToastMessage from 'src/helpers/toast-message'

const VerifyUserAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showError } = useToastMessage();
  const { verifyUserToken } = useParams();

  const [hasRunEffect, setHasRunEffect] = useState(false);

  const calledOnce = useRef(false);

  useEffect(() => {
    if (calledOnce.current) {
      return;
    }

    if (hasRunEffect === false) {
      dispatch({
        type: "SET_SHOW_POP_UP_BANNER",
        showPopUpBanner: false,
      });
      handleVerifyUserAccount(verifyUserToken);
      setHasRunEffect(true);
      calledOnce.current = true;
    }
  }, []);

  const handleVerifyUserAccount = async (token) => {
    dispatch({
      type: "SET_IS_LOADING",
      isLoading: true,
    });
    Axios({
      method: "post",
      url: `/api/sso/v1/users/verify/${token}`
    })
      .then(({ data }) => {
        if (data) {
          dispatch({
            type: "SET_IS_SUCCESS_VERIFY_USER",
            isSuccessVerifyUser: true,
          });
          dispatch({
            type: "SET_USER_DETAIL",
            user: data,
          });

          Axios({
            method: "post",
            url: `/api/tracker/v1/email/send/verify-user`,
            data: {
              user: {
                id: data?.id,
                email: data?.email
              }
            }
          })
            .then(() => {
              // success sending email verify user
            })
            .catch((err) => {
              console.error(err)
            })
        }
      })
      .catch((err) => {
        console.error(err);
        if (err && err.response && err.response.data) {
          const { response: { data: { message, success } = {} } = {} } =
            err || {};
          let finalMsg = "";
          if (message === "invalid-token") {
            finalMsg = "Invalid token";
          } else if (message === "user-verified-before") {
            finalMsg = "This account was verified before, please try to login.";
          } else if (message === "error-veify-user") {
            finalMsg = "Verify error";
          }
          const beforeFunction = () => {
            showError(finalMsg)
          };
          const afterFunction = () => {
            return dispatch({
              type: "SET_NOTIFICATION",
              notification: {
                success: false,
                msg: "",
                show: false,
              },
            });
          };
          timer(beforeFunction, afterFunction, 2000);
          navigate("/");
        }
      });
    dispatch({
      type: "SET_IS_LOADING",
      isLoading: false,
    });
  };

  return <Login />;
};

export default VerifyUserAccount;
